import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useAuth } from 'react-oidc-context';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

export default (props) => {
  const navigate = useNavigate();

  const auth = useAuth();

  function backToLogin() {
    auth.signinRedirect();
  }

  // useEffect(() => {
  //     if(auth.isAuthenticated){
  //         auth.signoutSilent()
  //     }

  //     fetch(`${window.origin}/api/users/accept-invite`, {
  //         method: "GET",
  //         headers: {
  //             "Content-Type": "application/json",
  //             "Authorization": `Bearer ${token}`
  //         }
  //     }).then(resp => resp.json()).then(data => {
  //         console.log(data)
  //     })

  // }, []);

  return (
    <>

      <div style={{ display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh' }}>
        <div style={{ display: 'flex', flexDirection: 'row', padding: '5vh 15vw', alignItems: 'center', height: '100vh' }}>

          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '1vw 10vw 5vw 10vw', color: 'rgb(0, 15, 30, 0.9)', backgroundColor: 'rgb(254, 254, 255, 0.8)', padding: '2vw 4vw', textAlign: 'center', borderRadius: '1.5vw' }}>
            <div style={{}}>
              <header style={{ marginBottom: '2vw' }}>
                <CheckOutlinedIcon style={{ color: '#1c6c6c', marginBottom: '1.5vw', fontSize: '3vw' }} />

                <h1 style={{ fontSize: '1.5vw', marginBottom: '1vw' }}>Invite Accepted</h1>
                <p style={{ fontSize: '0.85vw', margin: 0 }}>You have successfully accepted the invite</p>
              </header>

              <Button
                onClick={() => { navigate('/landing'); }}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '20vw', marginTop: '1vw' }}
              >
                Continue
              </Button>

            </div>
          </div>

        </div>

      </div>

    </>
  );
};
